import { render, staticRenderFns } from "./DownPaymentOtherItemSearchTab.vue?vue&type=template&id=6bd4b8e6&"
import script from "./DownPaymentOtherItemSearchTab.vue?vue&type=script&lang=ts&"
export * from "./DownPaymentOtherItemSearchTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VSimpleTable,VTextField})
